import { atom } from 'recoil';

export const isPaymentFilterModalOpenAtom = atom<boolean>({
  key: 'isPaymentFilterModalOpenState',
  default: false,
});
